// Manufacturing Packaging Header Arr
export const ManufacturingPackagingHeader = [
  "Sr.No",
  "Serial Code",
  "Picture",
  "SKU Code",
  "Product Group",
  "Action",
];

// Manufacturing Packaging Table Arr
export const packaging_table_arr = [
  {
    id: 1,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 2,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 3,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 4,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 5,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 6,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 7,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
  {
    id: 8,
    serialCode: "I-5341-05",
    picture: require("../Assets/Images/Ion.png"),
    sku_code: "T312-A",
    product_group: "T312-LMBLWH",
  },
];

// Previous Box Table Header Arr
export const Previous_Box_Header_arr = [
  "Sr.No.",
  "Box Number",
  <>
    Total Qty <br /> Scan
  </>,
  "Created By",
  "Created on",
  "Action",
];

export const ProductHeaderArr = [
  "Sr.No.",
  "SKU Code",
  "Picture",
  // "Product Group",
  "Quantity",
];
